var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.redraw})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }